import Auth from '@Services/Auth';
import { FEATURES } from '@Constants/rx-ui/constants';
import {
  AUTHOR_NAME_FILTER_ID,
  AUTHORS_OF_SCI_DOC_FILTER_ID,
  AFFILIATIONS_FILTER_ID,
  INVENTORS_OF_PATENTS_FILTER_ID,
} from '@Containers/ResultsFilters/ResultsFiltersConstants';

// eslint-disable-next-line import/prefer-default-export
export const isNewAuthorSearchFilterEnabled = (filterId) => {
  return (
    Auth.isFeatureEnabled(FEATURES.enableAuthorNameSearchImprovements) &&
    [AUTHOR_NAME_FILTER_ID, AUTHORS_OF_SCI_DOC_FILTER_ID, AFFILIATIONS_FILTER_ID, INVENTORS_OF_PATENTS_FILTER_ID].includes(filterId)
  );
};
